import { Link } from "react-router";

import { isCoach } from "@/components/helpers/workspace/permissions";
import { ChatComponent as Chat } from "@/components/pieces/chat/ChatComponent";
import { useWorkspaceMeetingChatQuery } from "@/graphql";

import { ChatSection } from "./ChatSection";

interface MeetingChatProps {
  meetingId: string;
  customerId: string;
  backLinkTo?: string;
  canChat: boolean;
}

export function MeetingChat({
  meetingId,
  customerId,
  backLinkTo,
  canChat,
}: MeetingChatProps) {
  const { loading, data } = useWorkspaceMeetingChatQuery({
    variables: { meetingId, customerId },
  });

  const channelId = data?.meeting?.chatChannelId ?? `Meeting_${meetingId}`;
  const channelName =
    isCoach() && data ? (
      <Link to={`/client/${data?.customer?.id}`}>View Profile</Link>
    ) : data && data.meeting ? (
      <Link to={`/sessions/${data.meeting.id}`}>
        {data.meeting.chatChannelTitle}
      </Link>
    ) : undefined;

  function ChatComponent({ height }: { height: number }) {
    return (
      <Chat channelId={channelId} height={height} customerId={customerId} />
    );
  }

  return (
    <ChatSection
      loading={loading}
      canChat={canChat}
      channelName={channelName}
      backLinkTo={backLinkTo}
      user={data?.customer}
      ChatComponent={ChatComponent}
    />
  );
}
